import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
	ListItem,
	UnorderedList,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const linkedInUrl = "https://www.linkedin.com/in/shatabdi-mukherjee-a0918148/";

const TheContextAIFDistributor: React.FC = () => (
	<>
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "400px", sm: "350px" }}
			minH={{ xs: "400px", sm: "350px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDirection="column"
			>
				<Flex
					alignItems={{ xs: "flex-start", md: "flex-start" }}
					justifyContent="center"
					columnGap="24px"
					justifyItems="center"
					width="100%"
					display="flex"
					as="section"
					rowGap="30px"
					flexDir={{
						xs: "column",
						md: "row",
					}}
				>
					<Flex flexDir="column" rowGap="16px">
						<Heading
							color="white"
							fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
							fontWeight="800"
							lineHeight={{ xs: "35px", lg: "83px" }}
						>
							#TheContext
						</Heading>
					</Flex>
					<Box
						w="1.5px"
						h={{ xs: "100%" }}
						bgColor="white"
						display={{ xs: "none", md: "block" }}
					/>
					<Box
						w={{ xs: "70%", sm: "60%" }}
						h="1.5px"
						bgColor="white"
						display={{ xs: "block", md: "none" }}
					/>
					{/*  */}
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						Up-skilling of AIF Distributors through NISM Certification
						Examinations
					</Heading>
				</Flex>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "40px" }}
				mb="20px"
			>
				<Flex
					flexDir={{
						xs: "column",
						md: "row",
					}}
					gap="20px"
					alignItems={{
						xs: "center",
						md: "unset",
					}}
				>
					<Img
						src="https://static.levocdn.com/WGLBUT82/ShatabdiMukherjee1-VbXYm3KbbYlH.jpg"
						alt="Shatabdi Mukherjee"
						width="250px"
						height="250px"
						objectFit="cover"
						borderRadius="50%"
					/>
					<Flex direction="column">
						<Heading
							as="h1"
							fontWeight="800"
							pt="20px"
							variant="reportCardTitle"
							fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
							textAlign={{
								xs: "center",
								md: "left",
							}}
							maxW={{
								xs: "100%",
								md: "120px",
							}}
						>
							Shatabdi Mukherjee
							<Link
								href={linkedInUrl}
								target="_blank"
								display={{ xs: "inline-block", md: "none" }}
								pl="10px"
							>
								<IconButton
									aria-label="linkedin"
									icon={<FaLinkedin size="28px" color="#067acc" />}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Heading>
						<Text
							color="text.mediumBlack"
							maxW={{
								xs: "100%",
								md: "120px",
							}}
							w="100%"
							fontSize="16px"
							lineHeight="22px"
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Senior Manager, NiSM
						</Text>

						<Link
							href={linkedInUrl}
							target="_blank"
							display={{
								xs: "none",
								md: "block",
							}}
						>
							<IconButton
								aria-label="linkedin"
								icon={<FaLinkedin size="28px" color="#067acc" />}
								variant="unstyled"
								cursor="pointer"
							/>
						</Link>
					</Flex>
				</Flex>
			</Box>
			<Box>
				<Box mt="16px" mb="20px">
					<Text variant="blogAnswer">
						A well trained workforce is always the backbone of economic growth
						stories. National Institute of Securities Markets (NISM) is pioneer
						in capacity building activities in securities markets through
						certifications, trainings, courses etc. It offers both mandated and
						aspirational certifications in various domains that helps in
						enhancing the skill set of the intermediaries in securities markets.
						The skills, expertise and ethics of professionals in the securities
						markets are crucial in providing effective intermediation to
						investors and in increasing the investor confidence in market
						systems and processes
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" pt="8px">
						As we know, Alternative Investment Fund (AIF) is a high ticket
						complex product that requires a thorough understanding by the
						prospective investors and all the intermediaries involved. NISM, as
						its capacity building initiative, has developed two certification
						examinations for the AIF Distributors in Category I & II
						(Series-XIX-A) and Category III (Series-XIX-B) respectively to
						improve the quality of the AIF market. These certification
						examinations seek to create a market-wide knowledge benchmark for
						persons working as distributors and placement agents in AIF domain
						in India. The objective of the examinations is to enhance the
						quality of sales and distribution, thereby enabling superior
						investor services.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Emphasizing on the quality of the certifications, NISM follows
						robust development and maintenance processes. The Examination
						Committee, consisting of industry experts, regulator representatives
						and domain specialists, plays a vital role in developing a practical
						and skill-oriented curriculum. Rich and engaging discussions and
						continuous feedback flow from the committee members help in
						incorporating relevant content and updating at regular intervals.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						Speaking particularly about Series-XIX-A: Alternative Investment
						Fund (Category I and II) Distributors Certification Examination, the
						certification provides an in-depth knowledge about the private
						capital ecosystem, the valuation methodologies, taxation, regulatory
						aspects etc. In order to make a successful sales pitch to
						prospective investors, an AIF Distributor is required to be abreast
						with all the functions/operations of the fund, which are all
						discussed in the workbook at length. Some of the important aspects
						discussed in the curriculum are as follows:
					</Text>
					<UnorderedList>
						<ListItem>
							<Text variant="blogAnswer" py="16px">
								Product suitability in relation to risk appetite and return
								expectation of the prospective investors has been discussed in
								detail.
							</Text>
						</ListItem>

						<ListItem>
							<Text variant="blogAnswer" py="16px">
								The purpose and processes of due diligence conducted by the Fund
								and Investors are thoroughly explained. The fund governance and
								monitoring fund performances have also been discussed.
							</Text>
						</ListItem>

						<ListItem>
							<Text variant="blogAnswer" py="16px">
								Understanding of the valuation techniques, investment processes
								and exit strategies adopted by the fund are covered extensively.
								Familiarisation of these aspects are especially important for
								the distributors as the prospective investors are interested in
								knowing about the return profile to expect and exit routes
								available to them.
							</Text>
						</ListItem>

						<ListItem>
							<Text variant="blogAnswer" py="16px">
								As the AIF industry is evolving at a rapid rate, keeping abreast
								with the newer regulatory developments are a must for any
								distributors. The exam covers all the relevant regulations/
								circulars along with their periodic updates, required for
								product marketing and answering investor queries.
							</Text>
						</ListItem>

						<ListItem>
							<Text variant="blogAnswer" py="16px">
								Provides a macro-level understanding of the various legal
								documentations involved in on-boarding of a prospective
								investor.
							</Text>
						</ListItem>

						<ListItem>
							<Text variant="blogAnswer" py="16px">
								Pre and Post commitment functions and appropriate code of
								conduct for distributors are being discussed in detail.
								Important aspects of a sales pitch and key constituents of
								distribution kit are enumerated.
							</Text>
						</ListItem>
					</UnorderedList>
				</Box>

				<Box my="16px">
					<Text variant="blogAnswer" mt="16px" mb="8px">
						In a nutshell, the Series-XIX-A: Alternative Investment Fund
						(Category I and II) Distributors Certification Examination provides
						all the necessary information relating to product and regulatory
						aspects for efficient performance by an AIF Distributor.
					</Text>
				</Box>

				<Box my="16px">
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Further details about the examination is provided at:{" "}
						<Link
							href="https://www.nism.ac.in/nism-series-xix-a-alternative-investment-funds-category-i-and-ii-distributors/"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							click here
						</Link>
					</Text>
				</Box>
			</Box>
			<Box width="100%" height="2px" bgColor="gray.700" />
			<Text
				variant="blogAnswer"
				lineHeight="30px"
				pt="18px"
				fontStyle="italic"
				p="12px 12px 0px"
				fontWeight="500"
			>
				<Text as="span" fontWeight="700" fontStyle="normal">
					#TheContext by IVCA
				</Text>{" "}
				– features opinion makers from the alternate investing industry with
				strong focus on India as an investment destination. Watch this space for
				new announcements in the sector, viewpoints on investment themes,
				emerging trends, economic reports, analysis and latest industry
				insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextAIFDistributor;
